import React, { useState, useEffect } from 'react';
import {
    ModalContainer,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalFormLabel,
    ModalForm,
    ImageGrid,
    SelectableImage,
    ModalCenterButton,
    ModalTextArea,
    ModalCloseButton,
    ModalButton,
    StoryTellerModalOverlay,
    OverviewBody,
    SpinningIcon,
    ModalOptionList,
    ModalOptionButton,
} from './StoryTellerElements';
import GenerateSceneAdaption from '../BedrockLibrary/SceneAdaption';
import GenerateCoverImage from '../BedrockLibrary/CoverGeneration';
import GeneratePrompt from '../BedrockLibrary/PromptGeneration';
import GeneratePageImagePrompt from '../BedrockLibrary/PageImagePrompt';
import GenerateSettingImage from '../BedrockLibrary/SettingGeneration';

const StoryTellerModal = ({ isOpen, onClose, onSave, story, firstPage = 0 }) => {

    const [pageNumber, setPageNumber] = useState(firstPage);
    const [storyData, setStoryData] = useState(story);
    const [imageOptions, setImageOptions] = useState();
    const [loadingBoolean, setLoadingBoolean] = useState(false);
    const [style, setStyle] = useState("")

    const [selectedOption, setSelectedOption] = useState('');

    const handleStyleSelection = (option) => {
        setStyle(option);
    }

    const handleNext = () => { setPageNumber(pageNumber + 1); setImageOptions() };
    const handlePrevious = () => { setPageNumber(pageNumber - 1); setImageOptions() };

    useEffect(() => {
        // console.log(story)
        setStoryData(story)
    }, [story]);

    const handleClose = () => {
        setLoadingBoolean(false);
        setPageNumber(0)
        onClose()
    }

    const handleSave = async (e, story) => {
        await onSave(e, story);
        setLoadingBoolean(false);
        onClose();
        // console.log(story)
    };

    if (!isOpen) return null;

    return (
        <StoryTellerModalOverlay>
            {storyData ?
                <>
                    {pageNumber === 0 && (
                        <ModalContainer hasImage={!!storyData.img} src={storyData.img}>
                            <ModalHeader>Overview</ModalHeader >
                            <ModalFormLabel >Title</ModalFormLabel>
                            <ModalForm type="text" name="title" value={storyData.title} />
                            <OverviewBody>
                                <ModalFormLabel>Description:</ModalFormLabel>
                                <ModalTextArea disabled={true} type="text" name="setting" value={storyData.description} />
                            </OverviewBody>
                            <ModalFooter>
                                <ModalCloseButton onClick={handleClose}>Close</ModalCloseButton>
                                <ModalButton onClick={handleNext}>Next</ModalButton>
                            </ModalFooter>
                        </ModalContainer>
                    )}
                    {pageNumber > 0 && (
                        storyData.pages[pageNumber - 1].img ?
                            <ModalContainer hasImage={true} src={storyData.pages[pageNumber - 1].img}>
                                < ModalHeader > {storyData.title}</ModalHeader >
                                < ModalBody >
                                    <ModalTextArea disabled={true} type="text" name="pages" value={storyData.pages[pageNumber - 1].text} />
                                </ModalBody >
                                <ModalFooter>
                                    <ModalCloseButton onClick={handleClose}>Close</ModalCloseButton>
                                    {pageNumber > 0 && <ModalButton onClick={handlePrevious}>Previous</ModalButton>}
                                    {pageNumber < storyData.pages.length ? (
                                        <ModalButton onClick={handleNext}>Next</ModalButton>
                                    ) : <></>}
                                </ModalFooter>
                            </ModalContainer >
                            : (
                                <ModalContainer>
                                    < ModalHeader > {storyData.title}</ModalHeader >
                                    < ModalBody >
                                        <ModalTextArea disabled={true} type="text" name="pages" value={storyData.pages[pageNumber - 1].text} />
                                    </ModalBody >
                                    <ModalFooter>
                                        <ModalCloseButton onClick={handleClose}>Close</ModalCloseButton>
                                        {pageNumber > 0 && <ModalButton onClick={handlePrevious}>Previous</ModalButton>}
                                        {pageNumber < storyData.pages.length ? (
                                            <ModalButton onClick={handleNext}>Next</ModalButton>
                                        ) : (
                                            <></>
                                        )}
                                    </ModalFooter>
                                </ModalContainer >))}
                </>
                : <></>}
        </StoryTellerModalOverlay >
    );
};


export default StoryTellerModal;
